import React from "react";
import styled from "styled-components";
import { TextVariant, TypographyNew } from "../typography/typography";
import EmployeeAvatarNew from "./EmployeeAvatarNew";
import LinkStyledComponent121, { AnchorLink } from "../buttonsLinks/LinkStyled";
import EmployeeCardCollapsed from "../../accounts/company/pages/employees/digitalPersonalFile/components/overview/EmployeeCardCollapsed";
import DataStatus from "../common/DataStatus";
import { WorkingStatus } from "../../redux/api-model/employees/workContract";
import { TimetrackingRequestDto } from "../../redux/api-model/employees/workSchedule";
import Watch from "../common/Watch";
import { useGeneralState } from "../../redux/general/selectors";
import {
  EmployeeAvatarDto,
  Role,
} from "../../redux/api-model/organization/company";
import { getProfileImageUrl } from "../../utils/profile";
import EmployeeAvatarSubTitle from "./EmployeeAvatarSubTitle";

const EmployeeCardContainer = styled.div`
  width: 100%;
  min-width: 170px;
  max-width: 250px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: default;
`;

export const AvatarLeftContainer = styled.div`
  position: relative;
  height: 40px;
  display: inline;
`;

export const AvatarRightContainer = styled.div`
  padding-left: 10px;
  height: 40px;
  display: inline-block;
  margin-left: 10px;
  line-height: 2px;
  max-width: 200px;
`;

const WatchContainerStyled = styled.div`
  display: flex;
  align-items: center;

  > *:first-child {
    flex: 0 1 auto;
  }

  > *:nth-child(2) {
    flex: 0 0 auto;
    padding-left: 6px;
    font-size: 13px;
    font-weight: 500;
    line-height: 15px;
  }
`;

export interface EmployeeAvatarProps {
  contractId: string;
  employeeId: string;
  firstName: string;
  lastName: string;
  position?: string | null;
  imgLink?: string | null;
  collapsed?: boolean;
  missingData: boolean;
  working?: WorkingStatus;
  workingTimetrackingRequest?: TimetrackingRequestDto | undefined;
  className?: string;
  showPersonalNr?: boolean;
  personalNr?: EmployeeAvatarDto["personalNr"];
  disabledLink?: boolean;
}

const EmployeeAvatar = (props: EmployeeAvatarProps): React.ReactElement => {
  const LinkC = props.disabledLink ? AnchorLink : LinkStyledComponent121;
  const general = useGeneralState();
  const employeeLink =
    general.userSelection.type == Role.WORK_CONTRACT_ACCESS
      ? `/app/me/contract/${props.contractId}`
      : `/app/employees/${props.employeeId}/contract/${props.contractId}`;
  const fullName = `${props.firstName} ${props.lastName}`;

  const returnObject = props.collapsed ? (
    <EmployeeCardCollapsed
      imgLink={props.imgLink}
      firstName={props.firstName}
      lastName={props.lastName}
      position={props.position}
      id={props.employeeId}
    />
  ) : (
    <EmployeeCardContainer className={props.className}>
      <AvatarLeftContainer>
        <EmployeeAvatarNew
          imgUrl={getProfileImageUrl(props.imgLink)}
          size={"SMALL"}
        />
        <DataStatus missingData={props.missingData} />
      </AvatarLeftContainer>
      <AvatarRightContainer>
        <LinkC to={employeeLink}>
          <TypographyNew
            variant={TextVariant.subtitle2}
            color="inherit"
            title={fullName}
            noWrap
          >
            {fullName}
          </TypographyNew>
        </LinkC>
        <WatchContainerStyled>
          <EmployeeAvatarSubTitle
            showPersonalNr={props.showPersonalNr}
            personalNr={props.personalNr}
            position={props.position}
          />
          <Watch
            working={props.working}
            workingTimetrackingRequest={props.workingTimetrackingRequest}
          />
        </WatchContainerStyled>
      </AvatarRightContainer>
    </EmployeeCardContainer>
  );
  return <>{returnObject}</>;
};

export default EmployeeAvatar;
